import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id,
    projId,
    content: inputContent,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.projectItem.save, {
        id,
        projId,
        content: inputContent,
    }, options);
    if (error) return { error, status };
    return content || {};
};

